<template>
  <div class="progress-bar__wrapper">
    <div class="progress-bar" :style="{transform: `scaleX(${lengthBar})` }">
      <div class="progress-bar__skew" :style="{transform: `skewX(${skewBar}deg)`}"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',

  props: ['lengthBar', 'skewBar'],
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';

.progress-bar {
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 100%;
  background: $color-blue;
  transition: transform 0.4s ease-out;
  will-change: transform;
  transform-origin: 0% 0%;
  &__wrapper {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 6px;
    width: 100%;
    z-index: 10;
  }
  &__skew {
    position: absolute;
    right: -10px;
    top: 0;
    width: 20px;
    height: 6px;
    transition: transform 0.2s ease-out;
    will-change: transform;
    background: $color-blue;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ProgressBar.vue